//
//
//
//
//
//
//
//
//
//
//
//
//

	import VueContentLoading from 'vue-content-loading';

	export default {
		name: "article-loader",
        components: {VueContentLoading}
	}
